export { ResourcesTable, RedirectingResourcesTable, type Columns as ResourcesTableColumns } from './Paginated'
